export const APP_ICON_SIZES = Object.freeze([16, 32, 64, 128]);
export const DEFAULT_ICON_SETTINGS = Object.freeze({ customSize: 48, actionSize: 32 });

export function normalizeIconSettings(config = {}) {
  config = config && typeof config === 'object' ? config : {};
  const customSize = Number(config.customSize);
  return {
    customSize:
      Number.isFinite(customSize) && customSize >= 8 && customSize <= 256
        ? customSize
        : DEFAULT_ICON_SETTINGS.customSize,
    actionSize:
      config.actionSize === 'custom' || APP_ICON_SIZES.includes(config.actionSize)
        ? config.actionSize
        : DEFAULT_ICON_SETTINGS.actionSize,
  };
}

export function resolveIconSize(size = 32, settings = DEFAULT_ICON_SETTINGS, customSize) {
  if (size === 'action') return resolveIconSize(settings.actionSize, settings);
  if (size === 'custom')
    return `${normalizeIconSettings({ customSize: customSize ?? settings.customSize }).customSize}px`;
  if (APP_ICON_SIZES.includes(Number(size))) return `${Number(size)}px`;
  // Compatibility with existing inline controls; new icons use a preset or `custom`.
  if (typeof size === 'number' && Number.isFinite(size) && size > 0) {
    return `${APP_ICON_SIZES.reduce(
      (nearest, preset) => (Math.abs(preset - size) < Math.abs(nearest - size) ? preset : nearest),
      16,
    )}px`;
  }
  return '32px';
}
